import { DEVIATION_LIST } from '../actions/deviations';

const defaultState = {
  deviationList: undefined,
};

const makeDeviationList = (state, deviationList) => ({
  ...state,
  deviationList,
});

export default (state = defaultState, action) => {
  const { type } = action;

  switch (type) {
    case DEVIATION_LIST: {
      const { deviationList } = action;
      return makeDeviationList(state, deviationList);
    }
    default: {
      return state;
    }
  }
};
